import React, { useEffect, useState } from 'react';
import { AddAdminModal } from './AddAdminModal';
import { GetAdminsResult } from './models';

export function ManageAdmins() {
  const [error, setError] = useState<string>();
  const [users, setUsers] = useState<AdminUser[]>([]);
  const [loggedInUserProfileId, setLoggedInUserProfileId] = useState<number>();
  const [addAdminUser, setAddAdminUser] = useState(false);

  useEffect(() => {
    getAdmins().then((data) => {
      const error = data.error;
      if (error) {
        setError(error);
      } else {
        const { adminUsers, loggedInUserProfileId } = data;
        setUsers(adminUsers);
        setLoggedInUserProfileId(loggedInUserProfileId);
      }
    });
  }, []);

  async function getAdmins(): Promise<GetAdminsResult> {
    const response = await fetch('/admin/admin-users');
    return await response.json();
  }

  async function switchAdminLevel(userProfileId: number, adminLevel: AdminLevel) {
    const response = await fetch('/admin/switch-admin-level', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ userProfileId, adminLevel })
    });
    if (response.status === 500) {
      const { error } = await response.json();
      setError(error);
      return;
    }
    window.location.reload();   
  }

  return (
    <div>
      {
        error &&
        <div className='notification is-danger mb-2 p-3'>
          {error}
        </div>
      }
      <h1 className='title'>
        Manage Admins
      </h1>
      <table className='table is-fullwidth'>
        <thead>
          <tr>
            <th className='relcol-30'>Email</th>
            <th className='relcol-30'>Name</th>
            <th className='relcol-20'>Admin level</th>
            <th className='relcol-20'>Account Status</th>
          </tr>
        </thead>
        <tbody>
          {
            users.length
              ? users.map(user => <tr key={user.userProfileId}>
                <td>
                  <a href={`/admin/user/${user.userProfileId}`}>
                    {user.email}
                  </a>
                </td>
                <td>
                  {user.username}
                </td>
                <td>
                  <div className='select is-small'>
                    <select
                      value={user.adminLevel}
                      onChange={(evt) => {
                        const level = evt.currentTarget.value as AdminLevel;
                        switchAdminLevel(user.userProfileId, level);
                      }}
                      disabled={user.userProfileId === loggedInUserProfileId}
                    >
                      <option value='organization'>Organization</option>
                      <option value='system'>System</option>
                    </select>
                  </div>
                </td>
                <td className='is-capitalized'>
                  {user.userStatus}
                </td>
              </tr>
              )
              : <tr></tr>
          }
        </tbody>
      </table>
      <button
        className='button is-link'
        type='button'
        onClick={() => setAddAdminUser(true)}
      >
        Add User
      </button>
      {
        addAdminUser
          ? <AddAdminModal
            onCancel={() => setAddAdminUser(false)}
            redirectUrl='/admin/manage_admins'
          />
          : <></>
      }
    </div>
  );
}

type AdminLevel = 'organization' | 'system';
type ActiveStatus = 'active' | 'inactive';

type AdminUser = {
  userProfileId: number;
  email: string;
  username: string;
  adminLevel: AdminLevel;
  userStatus: ActiveStatus;
};